import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { IndirectRateCostCenter } from './indirect-rate-cost-center.model';

export const loadIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Load IndirectRateCostCenters',
    props<{ indirectRateCostCenters: IndirectRateCostCenter[] }>()
);

export const addIndirectRateCostCenter = createAction(
    '[IndirectRateCostCenter/API] Add IndirectRateCostCenter',
    props<{ indirectRateCostCenter: IndirectRateCostCenter }>()
);

export const upsertIndirectRateCostCenter = createAction(
    '[IndirectRateCostCenter/API] Upsert IndirectRateCostCenter',
    props<{ indirectRateCostCenter: IndirectRateCostCenter }>()
);

export const addIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Add IndirectRateCostCenters',
    props<{ indirectRateCostCenters: IndirectRateCostCenter[] }>()
);

export const upsertIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Upsert IndirectRateCostCenters',
    props<{ indirectRateCostCenters: IndirectRateCostCenter[] }>()
);

export const updateIndirectRateCostCenter = createAction(
    '[IndirectRateCostCenter/API] Update IndirectRateCostCenter',
    props<{ indirectRateCostCenter: Update<IndirectRateCostCenter> }>()
);

export const updateIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Update IndirectRateCostCenters',
    props<{ indirectRateCostCenters: Update<IndirectRateCostCenter>[] }>()
);

export const deleteIndirectRateCostCenter = createAction(
    '[IndirectRateCostCenter/API] Delete IndirectRateCostCenter',
    props<{ id: string }>()
);

export const deleteIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Delete IndirectRateCostCenters',
    props<{ ids: string[] }>()
);

export const clearIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Clear IndirectRateCostCenters'
);

export const getIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Get IndirectRateCostCenters'
);

export const putIndirectRateCostCenters = createAction(
    '[IndirectRateCostCenter/API] Put IndirectRateCostCenters',
    props<{ indirectRateCostCenters: IndirectRateCostCenter[] }>()
);
